import Vue from "vue";

const gameActorsStore = {
	plugins: [],
	state: {},
	mutations: {
		// Expects a hash where the key is the Actor's id
		bulkUpdateGameActors(state, actorsData) {
			// pp.log("data", actorsData);
			Object.entries(actorsData).forEach(([actorId, actorData]) => {
				Vue.set(state, actorId, actorData);
			});
			pp.vue.bus.$emit("game-actors-UPDATE");
		},

		updateGameActor(state, { actorId, actorData }) {
			Vue.set(state, actorId, actorData);
			pp.vue.bus.$emit("game-actors-UPDATE");
			return state;
		},
	},

	getters: {
		gameActors:
			(state, getters) =>
			(filterActorIds = undefined) => {
				if (filterActorIds === undefined) {
					return state;
				}
				// else
				let remainingActorIds = Object.assign([], filterActorIds); // Need to clone array
				// pp.log("filter", filterActorIds);
				const filteredActors = Object.entries(state).filter(
					([actorId, actorItem]) => {
						const actorIdInt = parseInt(actorId);
						// @ts-expect-error
						const index = filterActorIds.indexOf(actorIdInt);
						if (index > -1) {
							// Only splice array when item is found
							// @ts-expect-error
							remainingActorIds.splice(index, 1); // 2nd parameter means remove one item only
							return true;
						} else {
							return false;
						}
					},
				);
				// pp.log("remaining", remainingActorIds, filteredActors);
				// Only for CMS view: Fetch the missing data
				// @ts-expect-error
				if (pp.currentActorId === undefined && remainingActorIds.length) {
					const setActorsData = (actorsData) => {
						Object.entries(actorsData).forEach(([actorId, actorData]) => {
							filteredActors.push([actorId, actorData]);
							Vue.set(state, parseInt(actorId), actorData);
						});
					};
					// pp.log("fetch", remainingActorIds, Object.keys(state));
					// @ts-expect-error
					remainingActorIds = remainingActorIds.filter((actorIdToFetch) => {
						return !Object.keys(state).includes(actorIdToFetch.toString());
					});
					// pp.log("fetch2", remainingActorIds);
					// @ts-expect-error
					if (remainingActorIds.length) {
						pp.vue.debounceAdminFetchActorsVueData(
							remainingActorIds,
							setActorsData,
						);
					}
				}
				// pp.log("returning", filteredActors)
				return Object.fromEntries(filteredActors);
			},
		actorData: (state, getters) => (actorId) => {
			return state[actorId];
		},
		actorWithAcronym: (state, getters) => (acronym, locale) => {
			return Object.values(state).find((actorObj) => {
				return actorObj.acronyms[locale] == acronym;
			});
		},
	},

	actions: {},
};

export default gameActorsStore;
